export default __webpack_public_path__ + "static/media/image-ph-study-report-n-m.61ec0fcd.png";